
namespace Cfnc {
    "use strict";

    interface ICfncMenuActive extends ng.IDirective {
    }

    interface ICfncMenuActiveScope extends ng.IScope {
    }

    interface ICfncMenuActiveAttributes extends ng.IAttributes {
        cfncMenuActive: string;
    }

    export class CfncMenuActive implements ICfncMenuActive {
        static directiveId: string = "cfncMenuActive";
        restrict: string = "A";
        replace: boolean = false;

        constructor(private $rootScope: ng.IRootScopeService, private $timeout: ng.ITimeoutService, private $route: ng.route.IRouteService) {

        }

        link = (scope: ICfncMenuActiveScope, element: ng.IAugmentedJQuery, attrs: ICfncMenuActiveAttributes) => {
            var isActive = () => {
                var route: any = this.$route.current;
                if (route.settings && route.settings.parent == attrs.cfncMenuActive) {
                    element.addClass("menu-active");
                }
                else {
                    element.removeClass("menu-active");
                }
            }

            isActive();

            this.$rootScope.$on("$routeChangeSuccess",
                () => {
                    this.$timeout(() => {
                        isActive();
                    });
                });
        }

    }
   

    angular.module("app").directive("cfncMenuActive", ["$rootScope", "$timeout", "$route", ($rootScope, $timeout, $route) =>
        new CfncMenuActive($rootScope, $timeout, $route)
    ]);
}